import "./Sidebar.css";

export class Sidebar {
  constructor(state) {
    this.state = state;
    this.element = null;

    this.menuItems = [
      {
        section: "Sources de Données",
        icon: "📊",
        items: [{ id: "config-global", label: "Configuration Globale" }],
      },
      {
        section: "Analyse & Rapports",
        icon: "📈",
        items: [
          { id: "validation-conflits", label: "Validation des conflits" },
          { id: "rapport-final", label: "Generation Rapport" },
        ],
      },
    ];

    this.state.on("pageChanged", () => this.updateActiveItem());
  }

  handleMenuClick(pageId) {
    this.state.setCurrentPage(pageId);
  }

  render() {
    const sections = this.menuItems
      .map((section) => {
        const items = section.items
          .map((item) => {
            const isActive = item.id === this.state.getCurrentPage();
            const activeClass = isActive ? "active" : "";

            return `
          <div class="menu-item ${activeClass}" data-page="${item.id}">
            ${item.label}
          </div>
        `;
          })
          .join("");

        return `
        <div class="menu-section">
          <div class="menu-header">
            ${section.icon} ${section.section}
          </div>
          ${items}
        </div>
      `;
      })
      .join("");

    return `
      <nav class="sidebar">
        ${sections}
      </nav>
    `;
  }

  updateActiveItem() {
    if (!this.element) return;

    this.element.querySelectorAll(".menu-item").forEach((item) => {
      item.classList.remove("active");
    });

    const activeItem = this.element.querySelector(`[data-page="${this.state.getCurrentPage()}"]`);
    if (activeItem) {
      activeItem.classList.add("active");
    }
  }

  bindEvents() {
    if (!this.element) return;

    this.element.querySelectorAll(".menu-item").forEach((item) => {
      item.addEventListener("click", () => {
        const pageId = item.dataset.page;
        this.handleMenuClick(pageId);
      });
    });
  }

  mount(selector) {
    const container = document.querySelector(selector);
    if (!container) {
      throw new Error(`Sidebar container ${selector} not found`);
    }

    container.innerHTML = this.render();
    this.element = container.querySelector(".sidebar");
    this.bindEvents();
  }

  unmount() {
    if (this.element) {
      this.element.remove();
      this.element = null;
    }
  }
}
